// iOS-style spring presets for framer-motion (mirrors the SwiftUI app's motion)
export const springs = {
  // Quick interactive elements: segmented-control pill, toggles
  snappy: { type: 'spring', stiffness: 440, damping: 34 },
  // Content entrances: page transitions, card reveals
  content: { type: 'spring', stiffness: 200, damping: 26 },
};

// Staggered fade-up entrance for card grids — 0.06s per index (iOS cadence)
export const staggerContainer = {
  initial: {},
  animate: { transition: { staggerChildren: 0.06 } },
};

export const fadeUpItem = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0, transition: springs.content },
};
